/*
  Takes time in string format 2:00 PM
  Converts to string format 14:00 
  TODO: replace filterSlots military time convert to use this
*/
export default function convertToMilitary(time) {
  let hour = time.split(':')[0];
  if (time.toLowerCase().includes('pm')) {
    if (Number(hour) !== 12) {
      hour = Number(hour) + 12;
    }
  } else if (time.toLowerCase().includes('am')) {
    if (Number(hour) === 12) {
      hour = 0;
    }
  }

  return hour.toString().length > 1 ? `${hour}:00` : `0${hour}:00`;
}
